<div style="position:relative;">
  <p-button severity="info"
          variant="text"
          (click)="openSearch(info,
          getContext(), true)"
          [disabled]="checkDisable()"
          aria-label="Manage links">

    <p-badge
      class="large"
      position="top left"
      severity="danger"
      *ngIf="linkCount() == 0" value="!">
    </p-badge>
    <p-badge
      class="large"
      position="top left"
      severity="info"
      *ngIf="linkCount() > 0"
      [value]="linkCount()"></p-badge>
    <i class="fas fa-link"></i>
  </p-button>
</div>
